<template>
  <el-form ref="formRef" :model="numberValidateForm" label-width="auto">
    <div class="max-request-config">
      <el-form-item
        :label="$t('t_max_request_per_user_minute')"
        prop="maxRequest"
        :rules="[
          {
            validator: validatePositiveInteger,
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-input-number
          v-model="numberValidateForm.maxRequest"
          :min="1"
          :step="1"
          controls-position="right"
          step-strictly
          autocomplete="off"
          clearable
          :placeholder="$t('t_max_request_per_user_minute_placeholder')"
        />
      </el-form-item>
      <el-button type="primary" @click="submitForm(formRef)">
        {{ $t("t-update") }}
      </el-button>
    </div>
  </el-form>
</template>

<script setup>
import { reactive, ref } from "vue";
import mushroom from "cem-primary-api";
import { Filter } from "mushroomjs";
import toastr from "toastr";
import MethodService from "../../service/MethodService";
import LanguageService from "../../service/LanguageService";

import { useI18n } from "vue-i18n";

const { t } = useI18n();
const formRef = ref();

const numberValidateForm = reactive({
  maxRequest: 0,
});

const validatePositiveInteger = (rule, value, callback) => {
  if (!value || !Number.isInteger(value) || value < 1) {
    callback(
      new Error(
        LanguageService?.lang?.valid_checkNumber_integer ??
          "Vui lòng nhập số nguyên dương"
      )
    );
  } else {
    callback();
  }
};

const maxRequestConfigAsync = async () => {
  try {
    const response = await mushroom.system_config.listAsync({
      filters: Filter.eq("key", "max_request_per_user_minute").build(),
      limit: 1,
    });
    if (response.result.length === 0) {
      await mushroom.system_config.createAsync({
        key: "max_request_per_user_minute",
        value: numberValidateForm.maxRequest || 0,
        is_public: true,
        note: "Giới hạn số truy vấn của một người dùng trong 1 phút",
      });
      toastr.success(t("toastr_update_success"));
      return;
    }
    await mushroom.system_config.partialUpdateAsync({
      id: response.result[0].id,
      value: numberValidateForm.maxRequest || 0,
    });
    toastr.success(t("toastr_update_success"));
  } catch (e) {
    console.error("Có lỗi: %o", e);
    MethodService.showError(e.code);
  }
};

const submitForm = (formEl) => {
  if (!formEl) return;
  formEl.validate(async (valid) => {
    if (valid) {
      await maxRequestConfigAsync();
    } else {
      console.log("error submit!");
    }
  });
};
</script>
<style scoped lang="scss">
.max-request-config {
  margin-left: 16px;
  margin-top: 1rem;
  display: flex;
  button {
    margin-left: 10px;
  }
  .el-input {
    width: 150px;
  }
}
</style>
